<template>
  <div>
    <div class="air__utils__heading">
      <h5>Staffs</h5>
    </div>

    <div class="row justify-content-center"  v-if="pagepermission.viewable">
      <div class="col-xl-12">

        <div class="row align-items-center mb-3">
          <div class="col-md-6 col-12">
            <div class="text-right">
              <a-input-search
                placeholder="Search Staffs"
                size="large"
                @search="searchStaffs"
                @change="searchStaffs"
              />
            </div>
          </div>

          <div class="col-md-6 col-12">
            <div class="d-sm-flex justify-content-end">
                <add-staff v-if="pagepermission.insertable" @created="handleCreated"/>
                <bulk-upload-staff class="mx-3" v-if="pagepermission.insertable" @uploaded="handleAfterUpload"/>
                <export-staff />
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <staffs-table :rolesetting="pagepermission" :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <template>
        <div>
          <a-spin :spinning="permissionCheckSpinning">
              <p class="error" v-if="!permissionCheckSpinning">
                You don't have permission to use this feature.
              </p>
          </a-spin>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import StaffsTable from '@/components/staff/Table/index'
import AddStaff from '@/components/staff/Forms/Add/index'
import BulkUploadStaff from '@/components/staff/Forms/Bulk/index'
import ExportStaff from '@/components/staff/Exports'

export default {
  components: {
    StaffsTable,
    AddStaff,
    BulkUploadStaff,
    ExportStaff,
  },
  beforeMount: function () {
    this.permissionCheckSpinning = true
    let rc = this.$roleutility.checkpermission('staff', 22)
    rc.then(data => {
      this.pagepermission = data.pagePermission
      this.permissionCheckSpinning = false
    })
  },
  mounted: function() {
    this.getStaffs()
  },
  created() {
    this.searchStaffs = debounce(this.searchStaffs, 500)
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 10,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
      sorterField: null,
      sorterOrder: null,
      permissionCheckSpinning: true,
    }
  },
  methods: {
    getStaffs: function(value) {
      this.loading = true
      this.$http.get('/api/teacher', {
        params: {
          limit: this.pageSize,
          page: this.current,
          search: value,
          sorter_field: this.sorterField,
          sorter_order: this.sorterOrder,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    searchStaffs: function(e) {
      this.getStaffs(e.target.value)
    },
    onSearch(value) {
      console.log('Search Values...', value)
    },
    handleCreated: function() {
      this.getStaffs()
    },
    handleAfterUpload: function () {

    },
    handleUpdateTable: function(args) {
      if (args !== null && args.length > 0) {
        this.sorterField = args[0]
        this.sorterOrder = args[1]
      }
      this.getStaffs()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getStaffs()
    },
    onChange(current) {
      this.current = current
      this.getStaffs()
    },
  },
}
</script>
